/* eslint-disable no-undef,one-var,no-mixed-operators */
let util = {}

util.tap = (function () {
  let _onStart
  let _onMove
  let _onEnd
  let _onCancel
  let _startPosX
  let _startPosY
  let _counter1
  let _counter2
  let _isTap
  let _supportTouch
  _supportTouch = !!(('ontouchstart' in window) || window.DocumentTouch &&
    document instanceof DocumentTouch)

  _onStart = function (e, active = '') {
    let point = e.changedTouches ? e.changedTouches[0] : e

    _startPosX = point.pageX
    _startPosY = point.pageY
    _isTap = true

    // 避免触摸滑动时过早加上active样式
    _counter1 = setTimeout(() => {
      util.addClass(this, active)
    }, 30)

    // 模拟长按
    _counter2 = setTimeout(() => {
      // 不是一个tap事件
      _isTap = false
      util.removeClass(this, active)
    }, 500)
  }

  _onMove = function (e, active) {
    let point = e.changedTouches ? e.changedTouches[0] : e,
      _currPosX = point.pageX,
      _currPosY = point.pageY

    if (_currPosX - _startPosX > 10 || _currPosY - _startPosY > 10) {
      _counter1 && clearTimeout(_counter1)
      _counter2 && clearTimeout(_counter2)
      _isTap = false
      util.removeClass(this, active)
    }
  }

  _onEnd = function (e, active) {
    let evt

    _counter2 && clearTimeout(_counter2)
    setTimeout(() => {
      util.removeClass(this, active)
    }, 100)
    if (_isTap) {
      // evt = new UIEvent('tap', {bubbles: true, cancelable: true})
      evt = document.createEvent('UIEvent')
      evt.initEvent('tap', true, true)
      this.dispatchEvent(evt)
      _isTap = false
    }
  }

  _onCancel = function (e, active) {
    _counter1 && clearTimeout(_counter1)
    _counter2 && clearTimeout(_counter2)
    _isTap = false
    util.removeClass(this, active)
  }

  if (_supportTouch) {
    return function (pelm, elm, fn, active) {
      if (typeof elm === 'function') {
        active = fn
        fn = elm
        elm = pelm
        pelm = false
      }
      util.on('touchstart', pelm, elm, function (e) {
        _onStart.call(this, e, active)
      })
      util.on('touchmove', pelm, elm, function (e) {
        _onMove.call(this, e, active)
      })
      util.on('touchend', pelm, elm, function (e) {
        // prevent ghost click
        e.preventDefault()
        _onEnd.call(this, e, active)
      })
      util.on('touchcancel', pelm, elm, function (e) {
        _onCancel.call(this, e, active)
      })
      util.on('tap', pelm, elm, function (e) {
        if (typeof fn === 'function') {
          fn.call(this, e)
        }
      })
      // fix bug in meizu mx5 oppo R9 android 5.1 browser
      util.on('touchstart', document, function () {})
    }
  } else {
    return function (pelm, elm, fn, active) {
      if (typeof elm === 'function') {
        active = fn
        fn = elm
        elm = pelm
        pelm = false
      }
      util.on('click', pelm, elm, function (e) {
        util.addClass(this, active)
        setTimeout(function () {
          util.removeClass(this, active)
        }, 100)
        fn.call(this, e)
      })
    }
  }
})()

util.addClass = function (elm, kls) {
  if (kls && !util.hasClass(elm, kls)) {
    elm.className += ' ' + kls
  }
}

util.removeClass = function (elm, kls) {
  let reg

  if (kls && util.hasClass(elm, kls)) {
    reg = new RegExp(kls.trim(), 'g')
    elm.className = elm.className.replace(reg, '')
  }
}

util.hasClass = function (elm, kls) {
  let isMatch = false,
    classes

  if (elm && elm.nodeType === Node.ELEMENT_NODE && kls) {
    classes = elm.className.split(' ')
    for (let i = 0; i < classes.length; i++) {
      if (classes[i] === kls) {
        isMatch = true
        break
      }
    }
    if (isMatch) return true
  }
  return false
}

util.remove = function (elm) {
  if (elm && elm.nodeType === Node.ELEMENT_NODE) {
    elm.parentNode && elm.parentNode.removeChild(elm)
  }
}

util.on = function (evt, ancestor, elm, fn) {
  if (typeof elm === 'function') {
    fn = elm
    elm = ancestor
    ancestor = false
  }
  if (ancestor) {
    if (typeof ancestor === 'string') {
      ancestor = document.querySelectorAll(ancestor)
    } else {
      ancestor = [].concat(ancestor)
    }
    if (typeof elm === 'string') {
      elm = document.querySelectorAll(elm)
    } else {
      elm = [].concat(elm)
    }
    // eslint-disable-next-line no-unused-vars
    ancestor.forEach((ant, idx) => {
      ant.addEventListener(evt, function (e) {
        console.log(e.target)
        for (let i = elm.length - 1; i >= 0; i--) {
          let parent = e.target.parentNode, el = elm[i]

          if (e.target === el) {
            // 此处event的currentTarget尚有问题，并且无preventDefault
            fn && fn.call(el, e)
            continue
          }
          while (parent && parent !== ant) {
            if (parent === el) {
              // 此处event的currentTarget尚有问题，并且无preventDefault
              fn && fn.call(el, e)
              break
            }
            parent = parent.parentNode
          }
        }
      }, false)
    })
  } else {
    if (typeof elm === 'string') {
      elm = document.querySelectorAll(elm)
    } else {
      elm = [].concat(elm)
    }
    // eslint-disable-next-line no-unused-vars
    elm.forEach((el, idx) => {
      el.addEventListener(evt, function (e) {
        fn && fn.call(this, e)
      }, false)
    })
  }
}

export default util
